import { ReorderDetailModel } from "./reorder-detail.model";

export class AdvancedReorderModel {
  productId: number;
  storeId: number;
  sku: string;
  description: string;
  subs: number;
  listings: number;
  fraction: number;
  supplierId: number;
  supplier: string;
  allSupplierIds: string;
  daysOfSupply: number;
  price: number;
  pricePlus: number;
  inventory: string;
  realTime: string;
  openPurchaseOrders: number;
  orders: number;
  reorder: number;
  reorderRaw: number;
  cbm: number;
  profit: number;
  basedOn: number;
  basedOnMonths: string;
  orderFor: number;
  orderForMonths: string;
  adjustment: number;
  outOfStock: boolean;
  buyBox: boolean;
  minusInventory: string;
  minusStoreInventory: string;
  minusOverstockedStoreInventory: string;
  minusOpenPurchases: boolean;
  manualEntry: number;
  advancedReorderRuleId: number;
  addedQuantity: number;
  totalInventory: number;
  locations: Map<number, number>;
  storeProducts: ReorderDetailModel[] = [];
  minusLocations: number[] = [];
  minusStores: number[] = [];
  details: string;
  included: boolean;
  hasSubRule: boolean;
  tags: string;
  tagIds: number[] = [];
}